import React from "react";
import styles from "./Hero.module.css";
import Button from 'react-bootstrap/Button';
import SouthEastIcon from '@mui/icons-material/SouthEast';

function Hero() {
    function scrollToPricing() {
        const pricingSection = document.getElementById("pricing");

        if (pricingSection) {
            pricingSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.log("pricing not found")
        }
    }

    return (
        <div className={styles["hero-container"]}>
            <div className={styles["hero-content"]}>
                <div className={styles["hero-tag"]}>
                    <img className={`${styles["hero-tag-emoji"]}`} src="./assets/images/emoji-hands.png" alt="emoji praise hands" />

                    <p>Free Tier Available!</p>
                </div>

                <h1>Free <span className={styles["red-txt"]}>Clinically Validated</span> Vital Sign Measurements.</h1>

                <p className={styles["hero-desc"]}>
                    Deploy in your app in less than an hour and 10 lines of code.
                </p>

                <Button 
                    className={styles["btn-primary"]} 
                    variant="primary"
                    onClick={scrollToPricing}
                >
                    Get Your API Key Now
                    <SouthEastIcon className={styles["btn-arrow"]}/>
                </Button>
            </div>
            
            {/* <img className={styles["light-wave"]} src="./assets/images/light-wave.png" alt="light wave" />
            <img className={styles["gradient-wave"]} src="./assets/images/gradient-wave.png" alt="gradient wave" /> */}
        </div>
    )
}

export default Hero;